/**
 * @description Displays the header of the page
 */

import React from 'react';
import Typography from '@mui/material/Typography';

const MappingHeader = () => (
  <Typography variant='h3' gutterBottom>
    Personnel Sync - Mapping Definition
  </Typography>
);

export default MappingHeader;
